import { useEffect, useState } from "react";
import { BellRing, X } from "lucide-react";
import { toast } from "sonner";
import { pushSupported, pushAsked, pushPermission, requestPushPermission } from "@/lib/push";

export function usePushOptIn() {
  const [show, setShow] = useState(false);
  const trigger = async () => {
    if (!pushSupported || pushAsked()) return;
    if ((await pushPermission()) === "prompt") setShow(true);
  };
  return { show, trigger, close: () => setShow(false) };
}

export function PushOptInSheet({ open, onClose, context = "Queres ser avisado no telemóvel quando houver novidades sobre as tuas encomendas, reservas e orçamentos?" }) {
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (!open) setBusy(false); }, [open]);
  if (!open) return null;
  const accept = async () => {
    setBusy(true);
    const res = await requestPushPermission();
    toast[res === "granted" ? "success" : "message"](res === "granted" ? "Notificações activadas" : "Podes activar mais tarde em Perfil → Notificações");
    onClose();
  };
  const later = () => { localStorage.setItem("auk_push_asked", "1"); onClose(); };
  return (
    <div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center bg-black/50 backdrop-blur-sm p-4 pb-20 sm:pb-4" onClick={later}>
      <div data-testid="push-optin-sheet" onClick={e => e.stopPropagation()} className="bg-white rounded-2xl w-full max-w-md p-5 shadow-xl">
        <div className="flex items-start justify-between">
          <div className="w-11 h-11 rounded-2xl bg-[#fff8d6] flex items-center justify-center"><BellRing size={22} className="text-[#c8102e]" /></div>
          <button onClick={later} data-testid="push-optin-close" className="p-1 rounded-full hover:bg-zinc-100"><X size={18} /></button>
        </div>
        <h2 className="font-display font-extrabold text-lg mt-3">Activar notificações?</h2>
        <p className="text-sm text-zinc-600 mt-1">{context}</p>
        <p className="text-[11px] text-zinc-400 mt-2">Podes escolher categorias e horas de silêncio em Perfil → Notificações.</p>
        <div className="flex gap-2 mt-4">
          <button onClick={later} data-testid="push-optin-later" className="flex-1 py-2.5 rounded-xl border border-zinc-200 text-sm font-semibold">Agora não</button>
          <button onClick={accept} disabled={busy} data-testid="push-optin-accept" className="flex-1 py-2.5 rounded-xl bg-[#c8102e] hover:bg-[#a50c24] text-white text-sm font-semibold disabled:opacity-50">{busy ? "…" : "Activar"}</button>
        </div>
      </div>
    </div>
  );
}
